module.exports = __webpack_public_path__ + "assets/5ddf5bb0edfea75f6e5c999092d3ea45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artwork-2.png
// module id = 387
// module chunks = 1